// flow weak

import React, {
    PureComponent
  }                             from 'react';
  import PropTypes              from 'prop-types';
  // import AnimatedView           from '../../../../components';
  import {
    defaultOptions,
    checkStatus,
    parseJSON,
    getLocationOrigin
  }                     from '../../../services/fetchTools';
  import styles                 from './style'
  import { withRouter } from 'react-router';
  import DatePicker from 'react-datepicker';
  import moment from 'moment';
  import Dialog from 'material-ui/Dialog'
  import FlatButton from 'material-ui/FlatButton';
  import RaisedButton from 'material-ui/RaisedButton';
  import {
    AnimatedView,
    StatsTable,ScoreCard,StatsGraph
  }                         from '../../../components';
  import {Link} from 'react-router-dom';
  import ReactTooltip from 'react-tooltip'

  import {
  TabPanel,
  TabPanelHeader,
  TabPanelBody,
  TabPanelBodyContent
} from '../../../components';
import { isNull } from 'util';
  
  class PartnerCourtBooking extends PureComponent {
    static propTypes = {
      earningGraphLabels:   PropTypes.array,
      revenueChart:  PropTypes.shape({
        headers: PropTypes.array,


        data: PropTypes.array
      }),
      earningGraphDatasets: PropTypes.array,
      teamMatesIsFetching:  PropTypes.bool,
      teamMates:            PropTypes.arrayOf(
        PropTypes.shape({
          picture:      PropTypes.string,
          firstname:    PropTypes.string,
          lastname:     PropTypes.string,
          profile:      PropTypes.string,
          profileColor: PropTypes.oneOf(['danger', 'warning', 'info', 'success'])
        })
      ),
      actions: PropTypes.shape({
        enterPage: PropTypes.func,
        leavePage: PropTypes.func,
      })
    };
  
    constructor(props) {
      super(props);
      this.state = {
        court_list: [],
        venue_list: [],
        game_list: [],
        selected_venue: '',
        selected_game: '',
        slot_list:{},
        booking_details: {},
        selected_date: moment(),
        cust_details:{
          customer_id:'',
          mobile_no: '',
          name: '',
          amount:'',
          source:'',
          selected_date: moment(),
          loading:false,
          payment_mode: '',
          is_blocked: false,
        },
        discount_amount: 0,
        slot_price:0,
        search:false,
        amount:'',
        customer_search_list: [],
        dialog_open_cust:true,
        isHovering:false,
        rental_revenue_per_day_graph_tabs: [ 
          {name: 'Data', tablink: '1', isActive: true}, 
          {name: 'Daily Court Usage', tablink: '2', isActive: false},
          
      ],
      rental_revenue_per_day: [ 
          {name: 'Data', tablink: '3', isActive: true}, 
          {name: 'Daily Rental', tablink: '4', isActive: false},
          
      ], 
      payment_modes: [],
      };
      this.handleVenueChange = this.handleVenueChange.bind(this);
      this.handleShowSlots = this.handleShowSlots.bind(this);
      this.handleSlots = this.handleSlots.bind(this);
      this.searchCustomer = this.searchCustomer.bind(this);
      this.handleChange = this.handleChange.bind(this);
      this.handleCustomerSubmit = this.handleCustomerSubmit.bind(this);
      this.handleDate = this.handleDate.bind(this);
      this.handleGameChange = this.handleGameChange.bind(this);
    }
  
    componentDidMount() {
      const {
        actions: {
          fetchStatsTableDataIfNeeded,
        }
      } = this.props;
      this.getVenueList();
      this.paymentModes();

    $('.collection-trend').find("a").trigger("click");
    $('.daily-trend').find("a").trigger("click");
    }
    paymentModes(){
      const url = `${getLocationOrigin()}/eagleeye/get_details_for_fixture_creation/`;
     const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
           this.setState({payment_modes:data.payment_modes});
           // alert("fix");
       }).catch(error => error);
    }
  
    getVenueList(){
      const url = `${getLocationOrigin()}/court/get_venues_for_court/`;
       const options = {...defaultOptions};
  
      return fetch(url, options)
         .then(checkStatus)
         .then(parseJSON)
         .then(data => this.setState({ venue_list: data.results, selected_venue: data.results[0].id, game_list: data.results[0].games,selected_game: data.results[0].games[0].game_id},()=>{this.getSlots()}))
         .catch(error => error);
    }

    handleVenueChange(event){
      console.log('eveny')
      console.log(event.target.value)
      this.state.game_list = this.state.venue_list.filter(venue => venue.id == event.target.value)[0].games
      // var new_game_id = this.state.game_list[0].game_id
      console.log(this.state.venue_list)
      console.log(this.state.game_list)
      this.setState({selected_venue:event.target.value,selected_game:this.state.game_list[0].game_id})
      // this.getSlots(event.target.value)
    }

    handleGameChange(event){
      this.setState({selected_game:event.target.value})
      // console.log(this.state.selected_game)
    }

    handleSlots(obj){
      console.log('obj')
      console.log(obj)
      this.setState({loading:true})
      if(obj.is_blocked === true){
      this.setState({is_blocked:true })
      }

      const url = `${getLocationOrigin()}/court_booking/get_details_for_court_booking/?court_booking_id=${obj.id}`;
      const options = {...defaultOptions};
  
      return fetch(url, options)
         .then(checkStatus)
         .then(parseJSON)
         .then(data => this.setState({ booking_details: data,slot_price:data.price,slot_total_price:data.price,discount_amount:0,loading:false}))
         .catch(error => error);

      console.log('sss')

    }

    handleClose = () => {
      this.setState({dialog_open_cust:false});
    };

    handleOpen=()=>{
      this.setState({dialog_open_cust:true})
    }

    handleCustomerSubmit(){
      console.log('post');
        
      const url = `${getLocationOrigin()}/eagleeye/add_new_customer/`;
      const options = {...defaultOptions};
      options['method'] = 'post';
      options['headers'] = {'content-type': 'application/json'}
      options['body'] = JSON.stringify({
                          'customer_name': this.state.cust_details.name,
                          'customer_mobile': this.state.cust_details.mobile_no,
                        });
      console.log('Going to fetch');
      return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .catch(error => {
          console.log(error);
          alert(error.message);
        })
        .then(data => {
          if(data.success){
            var cust = Object.assign([], this.state.cust_details);
            cust.push({'id': data.customer.id, 'name': data.customer.name, 'mobile_no':data.customer.mobile_no});
            this.setState({customer_search_list: cust});
            alert(data.message);
            this.handleClose();
          } else {
            alert(data.message);
          }
         });
    }

    getSlots(){
      console.log("im here");
      this.setState({loading:true,booking_details:{}})
      var venue_id = this.state.selected_venue
      var selected_date = moment(this.state.selected_date).format("YYYY-MM-DD")
      var game = this.state.selected_game
      const url = `${getLocationOrigin()}/court_booking/get_court_booking_state/?venue_id=${venue_id}&date=${selected_date}&game=${game}`;
       const options = {...defaultOptions};
  
      return fetch(url, options)
         .then(checkStatus)
         .then(parseJSON)
         .then(data => this.setState({ slot_list: data.slots,court_list:data.court_names,loading:false}))
         .catch(error => error);
      
    }

    handleShowSlots(){
      this.getSlots()
    }

    handleChange(event) {
      const name = event.target.name;
      var new_selected_one =  Object.assign({}, this.state.cust_details);
      new_selected_one[name] = event.target.value
      console.log(new_selected_one)
      this.setState({cust_details: new_selected_one});
      console.log(this.state)
    }

    handleDate(date){
      this.setState({selected_date: date});
    }

    cancelBooking(court_booking_id){
      const url = `${getLocationOrigin()}/court/cancel_court_booking_from_portal/`;
      const options = {...defaultOptions};
      options['method'] = 'post';
      options['headers'] = {'content-type': 'application/json'}
      options['body'] = JSON.stringify({'court_booking_id': court_booking_id,
                                            });
      console.log('Going to fetch');
      return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then(function(response){                      
            alert(response.message);
        })
        .catch(error => {
          console.log(error);
          alert(error.message);
        });
    }

    updateSubscription(court_booking_id){
      const url = `${getLocationOrigin()}/court_booking/update_rental_subscription/`;
      const options = {...defaultOptions};
      options['method'] = 'post';
      options['headers'] = {'content-type': 'application/json'}
      options['body'] = JSON.stringify({'court_booking_id': court_booking_id,
                                        'amount':this.state.amount
                                            });
      console.log('Going to fetch');
      return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then((response) => {                      
            alert(response.message);
            this.setState({amount:''})
        })
        .catch(error => {
          console.log(error);
          alert(error.message);
        });
    }

    cancelBookingPress(court_booking_id){
      this.cancelBooking(court_booking_id)
      // this.getSlots();
    }

    updateSubscriptionPress(court_booking_id){
      if(this.state.amount != ''){
      this.updateSubscription(court_booking_id)
    }
    else{
      alert("Enter Amount")
    }
    }

    getSearchList(mobile_no) {
      const url = `${getLocationOrigin()}/eagleeye/search/`;
      const options = {...defaultOptions};
      options['method'] = 'post';
      options['headers'] = {'content-type': 'application/json'}
      options['body'] = JSON.stringify({
                           'search': mobile_no
                         });
      return fetch(url, options)
         .then(checkStatus)
         .then(parseJSON)
         .then(data => this.setState({customer_search_list: data.results, search: true}))
         .catch(error => {
           console.log(error);
           alert(error.message);
         });
    }

    addBooking(){
      console.log('rental')
    var date = moment(this.state.selected_date).format("YYYY-MM-DD")
    if(!this.state.booking_details.source){this.state.booking_details.source="Other"}
    const url = `${getLocationOrigin()}/eagleeye/add_rental/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                        'customer_id': this.state.cust_details.customer_id,
                        'court':this.state.booking_details.court.id,
                        'start_time': this.state.booking_details.start_time,
                        'amount': this.state.slot_price,
                        'date': date,
                        'source':this.state.cust_details.source,
                        'payment_mode': this.state.cust_details.payment_mode,
                        'discount_amount':this.state.discount_amount
                      });
    console.log('Going to fetch');
    console.log(options['body'])
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(function(response){                      // first then()
          alert(response.message);
          window.location.reload();
        })
      .then(()=>{this.getSlots()})
      .catch(error => {
        console.log(error);
        alert(error.message);
      });
      
      func()
    }

    onAddBookingPress(){
      {this.state.cust_details.customer_id  ?
        this.addBooking()
        :
        alert("Please Enter Details")
    }

    }

    handleDiscountApply = () => {
      if(this.state.discount_amount > this.state.slot_price){
        var slot_price = 0
        this.setState({slot_price:slot_price})
      }
      else{
        var slot_price = this.state.slot_total_price - this.state.discount_amount
        this.setState({slot_price:slot_price}) 
      }
    }

    searchCustomer() {
      {this.state.cust_details.mobile_no?this.getSearchList(this.state.cust_details.mobile_no):
        alert('Search cannot be blank')}
    }

    setSearch(name, customer_id, mobile_no){
      var new_selected_one =  Object.assign({}, this.state.cust_details);
      new_selected_one['customer_id'] = customer_id
      new_selected_one['mobile_no'] = mobile_no
      new_selected_one['name'] = name
      this.setState({cust_details: new_selected_one, search: false});
    }

    updateRenatal(id){
      console.log('updateREnat')
      const url = `./crud/updateCourtBooking/${id}`;
      <Link to = {url} />
    }
  
    render() {
      console.log('render')
      console.log(this.state.selected_game)
      console.log(this.state.court_list)
      const actions = [
        <FlatButton
          label="Cancel"
          primary={true}
          onClick={this.handleClose}
        />,
        <FlatButton
          label="Submit"
          primary={true}
          onClick={this.handleCustomerSubmit}
        />,
      ];
      const {
        statsTable, scoreCard,statsGraph
      } = this.props;
  
      const {
        actions: {
          fetchStatsTableDataIfNeeded,fetchScoreCardDataIfNeeded,fetchStatsGraphDataIfNeeded
        }
      } = this.props;
    return(
        <div>
        <div className="row">
          <ScoreCard name="score_card_rental" data={scoreCard} reloadData={fetchScoreCardDataIfNeeded}/>
        </div>

        <div className='row'>
          <div className="col-md-2" style={{float: 'right'}}>
               <Link to={`./crud/foodRental`} target="_blank">
              <FlatButton
                backgroundColor="#c6ff00"
                label="F&B Rental"
                style={{marginLeft: '10px', }}
              />
              </Link>
              </div>

              <div  style={{flexDirection: 'row', justifyContent: 'space-between', padding: '1px'}}>
                  <Link to={`./crud/addRental`} target="_blank">
                      <FlatButton
                        backgroundColor="#ec407f"
                        label="Block Court"
                        style={{float:'right', marginLeft: '5px'}}
                      />
                    </Link>
                    <Link to={`./crud/addBulkBooking`} target="_blank">
                      <FlatButton
                        backgroundColor="#ec407f"
                        label="Bulk Booking"
                        style={{float:'right'}}
                      />
                    </Link>
                  </div>
        </div>

        <div style={{margin:10}}> 
          <div className="row">    
          <div className="row col-md-12" style={styles.table}>
            
            <div className="col-md-12" style={{flexDirection:'row',textAlign:'center'}}>
              
              <div className="col-md-2" style={{padding:'1%'}}> 
                <DatePicker selected={this.state.selected_date} onChange={this.handleDate}/>
              </div>

              <div style={styles.items} className="col-md-2">
                <select name="venue" className="col-md-10" style={styles.item_body} value={this.state.value}
                  onChange={this.handleVenueChange}>
                  {
                    this.state.venue_list.map((x, index) => (
                    <option key={x.id} value={x.id}>{x.name}</option>
                    ))
                  }
                </select>
              </div>

              <div style={styles.items} className="col-md-2">
                <select name="game" className="col-md-10" style={styles.item_body} value={this.state.selected_game}
                  onChange={this.handleGameChange}>
                  {
                    this.state.game_list.map((x, index) => (
                    <option key={x.game_id} value={x.game_id}>{x.game_name}</option>
                    ))
                  }
                </select>
              </div>

              <div className="col-md-2" style={{backgroundColor:'#32B6A7',}}>
                  <FlatButton
                    label="SHOW SLOTS"
                    style={{color:'black'}}
                    primary={true}
                    onClick={this.handleShowSlots}
                  />
              </div>
            </div>
          

          {this.state.loading === true ?
                <div style={{height:500}}>
                  <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}>loading...</div>

                  </div>
            :
          <div>
          {Object.keys(this.state.booking_details).length > 0 && this.state.booking_details.is_booked == true &&
            <div className="row col-md-12" style={{margin:'1%',border:'1px solid grey',backgroundColor:'white'}}>
              <div style={{fontSize:20,color:'black',textAlign:'center',marginBottom:10,marginTop:10}}>Booking Details</div>
                <div className="row col-md-12" style={{paddingLeft:'10%'}}>
                  <div className="row col-md-4">Name: {this.state.booking_details.booking_details.customer_name}</div>
                  <div className="row col-md-4">Mobile No: {this.state.booking_details.booking_details.customer_mobile_no}</div>
                  <div className="row col-md-4">Amount: <input type="number" style={styles.input} className="required" name="amount" value={this.state.amount}
                    onChange={(event)=>{this.setState({amount:event.target.value})}}/></div>
                </div>
                <div className="row col-md-12" style={{paddingLeft:'10%'}}>
                  <div className="row col-md-4">Court: {this.state.booking_details.court.name}</div>
                  <div className="row col-md-4">Start Time: @{this.state.booking_details.start_time}</div>
                  
                </div>
                <div className="row col-md-12" style={{marginTop:20,marginBottom:20,paddingLeft:'10%'}}>
                <Link to = {`./crud/updateCourtBooking/${this.state.booking_details.id}`}>
                <div className="row col-md-4"><button onClick={()=>{}} style={{width:'90%',color:'white',backgroundColor:'#0c6d79',marginLeft:1}}>Update Equipment Rental</button></div>
                  </Link>
                  <div className="row col-md-4"><button onClick={()=>{this.cancelBookingPress(this.state.booking_details.id)}} style={{width:'90%',color:'white',backgroundColor:'#0c6d79',marginLeft:1}}>Cancel Booking</button></div>
                  <div className="row col-md-4"><button onClick={()=>{this.updateSubscriptionPress(this.state.booking_details.id)}} style={{width:'90%',color:'white',backgroundColor:'#0c6d79',marginLeft:1}}>Update Amount</button></div>
                </div>
            </div>
          }
          {Object.keys(this.state.booking_details).length > 0 && this.state.booking_details.is_booked == false &&
            <div className="row col-md-12" style={{margin:'1%',border:'1px solid grey',backgroundColor:'white'}}>
              <div style={{fontSize:20,color:'black',marginBottom:10,textAlign:'center'}}>Block</div>
                <div style={{fontSize: '120%',fontWeight: 600,paddingLeft: '10%',}} className="col-md-6">
                  Customer No
                </div>
                <div className="col-md-6 input-group">
                  <input type="text" name="mobile_no" className="form-control"
                    placeholder={this.state.cust_details.mobile_no +this.state.cust_details.name}  onChange={this.handleChange}/>
                  <span className="input-group-btn">
                    <button className="btn btn-default glyphicon glyphicon-search"
                    type="button" onClick={this.searchCustomer}></button>
                  </span>
                </div>
                {this.state.search?
              <div className="col-md-12 btn-group">
                {this.state.customer_search_list.length?this.state.customer_search_list.map((x) =>(<button key={x.mobile_no+x.name} className="btn btn-default"
            style={{padding:'1%'}} onClick={() => this.setSearch(x.name,x.id, x.mobile_no)}>{x.name}:{x.mobile_no}</button>))
            :<div className="alert alert-danger" style={{justifyContent: 'space-between', display: 'flex'}}>
            <div className="alert alert-danger">Search customer not found</div>
            <div>
                <RaisedButton
                  onClick={this.handleOpen}
                  label="Add"
                  style={{float:'right'}}
                  secondary={true}
                />
                <Dialog
                  actions={actions}
                  modal={false}
                  open={this.state.dialog_open_cust}
                  onRequestClose={this.handleClose}
                >
                  <div>
                      <div style={styles.main_header} className="col-md-12">
                          <h3 style={{textAlign:'center'}}>Add New Customer</h3>
                        </div>
                            <div style={styles.items} className="col-md-12">
                              <div style={styles.item_header} className="col-md-6">
                                Name
                              </div>
                              <input type="text" style={styles.input} name="name" className="required"
                                value={this.state.value} onChange={this.handleChange}/>
                            </div>

                            <div style={styles.items} className="col-md-12">
                              <div style={{fontSize: '120%',fontWeight: 600,paddingLeft: '11%',}} className="col-md-6">
                                Mobile No
                              </div>
                            <input type="number" style={styles.input} name="mobile_no" className="required"
                              value={this.state.cust_details.mobile_no} onChange={this.handleChange}/>
                          </div>
                        </div>
                      </Dialog>
                    
                    </div>

                    </div>
                }</div>:''

              }

                <div className="col-md-12" style={styles.items}>
                  <div className="col-md-6" style={styles.item_header}>Court:</div>
                  <div className="col-md-6">{this.state.booking_details.court.name}</div>
                </div>
                <div className="col-md-12" style={styles.items}>
                  <div className="col-md-6" style={styles.item_header}>Start Time: </div>
                  <div className="col-md-6">@{this.state.booking_details.start_time}</div>
                </div>
                  <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-6">
                    Slot Price: 
                  </div>
                  <div className="col-md-6">
                  {this.state.booking_details.price}
                    </div>
                    </div>
                  <div style={styles.items} className="col-md-12">
                    <div style={styles.item_header} className="col-md-6">
                      Discount
                    </div>
                    <div className="col-md-3">
                        <input type="number" style={styles.input} name="discount_amount" className="required"
                          value={this.state.discount_amount} onChange={(event)=>{this.setState({discount_amount:event.target.value})}}/>
                    </div>
                    <div className="col-md-3">
                      <button
                        type="button"
                        onClick={this.handleDiscountApply}>
                          Apply
                      </button>
                    </div>
                  </div>
                  <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-6">
                    Amount
                  </div>
                  <div className="col-md-6">
                      {this.state.slot_price}
                    </div>
                  {/* <input type="number" style={styles.input} name="amount" className="required"
                    value={this.state.value} onChange={this.handleChange}/> */}
                  </div>
                   <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-6">
                    Source
                  </div>
                  <select name="source" className="col-md-6" style={styles.item_body} value={this.state.value}
                    onChange={this.handleChange}>
                    <option value>-------</option>
                      <option>Other</option>
                      <option>PLAYO</option>
                      <option>WALK IN</option>
                  </select>
                </div>
                 <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-6">
                    Payment Modes
                  </div>
                 <select name="payment_mode" className="col-md-6" style={styles.item_body} value={this.state.value}
                   onChange={this.handleChange}>
                    {
                       Object.keys(this.state.payment_modes).map((key, index) => (
                       <option key={key} value={key}>{`${this.state.payment_modes[key]}`}</option>
                       ))
                     }
              </select>
                </div>
                <div className="row col-md-12" style={{marginTop:10,marginBottom:10,textAlign:'center'}}>
                  <button onClick={()=>{this.onAddBookingPress()}} style={{width:'25%',color:'white',backgroundColor:'#0c6d79',marginLeft:1}}>Block</button>
                </div>
              </div>
          }

            <div className="row col-md-12" style={{paddingLeft:'5%',marginTop:20}}>
            {Object.keys(this.state.slot_list).length > 0 &&
            <div className="row col-md-12" style={{backgroundColor:'#00BBD6'}}>
                <div className="row col-md-2" style={{fontSize:18,color:'white',width:'10%',height:'30px'}}>Time Slot</div>
                <div className="row" style={{textAlign:'center'}}>
                  {this.state.court_list.map((court, index)=>{
                    return(
                      <div className="row col-md-2" style={{fontSize:18,color:'white',width:'15%',height:'30px',marginLeft:'10px'}}>{court}</div>
                    )
                  })}
                  
                </div>
            </div>
            }
            {Object.keys(this.state.slot_list).sort().map((v, i)=> {
              return(
                <div>
                 <div className="row col-md-12" style={{paddingTop:10}}>
                  <div className="row col-md-1">{v}</div>
                    <div className="row" style={{flexDirection:'row'}}>
                    {this.state.slot_list[v].sort((a,b)=>{return (a.court.name > b.court.name) ? 1 : ((b.court.name > a.court.name) ? -1 : 0)}).map((obj,index)=>{
                      return(
                        <div>
                      <div className="col-md-2" style={{width:'15%',height:'30px'}}>
                      {/* {obj.is_blocked === false ?  */}
                        <button onClick={()=>{this.handleSlots(obj)}} style={(obj.status === true)? {width:'120%',height:'30px',color:'white',backgroundColor:`${obj.booking.color}`}:{width:'120%',height:'30px',color:'white',backgroundColor:'grey',}}>
                          {obj.is_equipment_updated === true ? <span>{<i className="fa fa-dribbble"></i>}</span> : <div />}
                          {obj.status === true ? obj.is_blocked === true ?
                          <a data-for='global_one' data-tip={`${obj.booking.name}|${obj.booking.mobile_no}|${obj.booking.source}|${obj.booking.amount}|${obj.is_equipment_updated}|${obj.reason}|${obj.batch_size}|${obj.voted_in}`}  style={{color:'white'}}>{obj.booking.name === '' ? (obj.booking.mobile_no) : (obj.booking.name)}</a>
                          :
                          <a data-for='global' data-tip={`${obj.booking.name}|${obj.booking.mobile_no}|${obj.booking.source}|${obj.booking.amount}|${obj.booking.booking_amount}|${obj.booking.price}|${obj.is_equipment_updated}`}  style={{color:'white'}}>{obj.booking.name === '' ? (obj.booking.mobile_no) : (obj.booking.name)}</a>: "Book"}
                        </button>     
                        </div>
                        </div>
                      )
                    })}
                 </div>
                 </div>
                 </div>
              )
              })}

               <ReactTooltip id='global_one'
                            getContent={(dataTip) =>{
                              if (!dataTip) {
                                return "";
                              }
                              const [name,number,source,amount,equipment,reason,batch_size,voted_in] = dataTip.split("|")
                              return(
                                <div className="col-md-12">
                                  <div className="row" style={{fontSize:12}}>Name: {name}</div>
                                  <div className="row" style={{fontSize:12}}>Mobile: {number}</div>
                                  <div className="row" style={{fontSize:12}}>Source: {source}</div>
                                  <div className="row" style={{fontSize:12}}>Equipment: {(equipment === 'true') ? <span>Yes</span> : <span>No</span>}</div>
                                  <div className="row" style={{fontSize:12}}>Reason: {reason}</div>
                                  <div className="row" style={{fontSize:12}}>Batch Size: {batch_size}</div>
                                  <div className="row" style={{fontSize:12}}>Voted In: {voted_in}</div>
                                </div> )}}
                                 effect='solid'
                                 place={'top'}
                                 border={true}
                                 type={'light'}/>

                 <ReactTooltip id='global'
                            getContent={(dataTip) =>{
                              if (!dataTip) {
                                return "";
                              }
                              const [name,number,source,amount,booking_amount,price,equipment] = dataTip.split("|")
                              return(
                                <div className="col-md-12">
                                  <div className="row" style={{fontSize:12}}>Name: {name}</div>
                                  <div className="row" style={{fontSize:12}}>Mobile: {number}</div>
                                  <div className="row" style={{fontSize:12}}>Source: {source}</div>
                                  <div className="row" style={{fontSize:12}}>Total Amount: {amount}</div>
                                  <div className="row" style={{fontSize:12}}>Slot Amount: {booking_amount}</div>
                                  <div className="row" style={{fontSize:12}}>Slot Price: {price}</div>
                                  <div className="row" style={{fontSize:12}}>Equipment: {(equipment === 'true') ? <span>Yes</span> : <span>No</span>}</div>
                                </div> )}}
                                 effect='solid'
                                 place={'top'}
                                 border={true}
                                 type={'light'}/>
            </div>
            </div>
          }
          </div>
        </div>
        <div className="row col-md-12" style={{padding: '2%',justifyContent:'center',marginLeft:'6%'}}>
        <div className="row col-md-2">
          <div className="row col-md-12" style={{width:20,height:20,border:'1px solid grey',backgroundColor:'rgba(255,204,0,0.8)'}}></div>
          <div className="row col-md-12" style={{fontSize:14, marginLeft:7}}>Internal Blocking</div>
        </div>
        <div className="row col-md-2">
          <div className="row col-md-12" style={{width:20,height:20,border:'1px solid grey',backgroundColor:'#1B30EC'}}></div>
          <div className="row col-md-12" style={{fontSize:14, marginLeft:7}}>Bulk Booking</div>
        </div>
        <div className="row col-md-2">
          <div className="row col-md-12" style={{width:20,height:20,border:'1px solid grey',backgroundColor:'#388585'}}></div>
          <div className="row col-md-12" style={{fontSize:14, marginLeft:7}}>App</div>
        </div>
        <div className="row col-md-2">
          <div className="row col-md-12" style={{width:20,height:20,border:'1px solid grey',backgroundColor:'#888c0f'}}></div>
          <div className="row col-md-12" style={{fontSize:14, marginLeft:7}}>Website</div>
        </div>
        <div className="row col-md-2">
          <div className="row col-md-12" style={{width:20,height:20,border:'1px solid grey',backgroundColor:'#1f960d'}}></div>
          <div className="row col-md-12" style={{fontSize:14, marginLeft:7}}>Playo</div>
        </div>
        <div className="row col-md-2">
          <div className="row col-md-12" style={{width:20,height:20,border:'1px solid grey',backgroundColor:'crimson'}}></div>
          <div className="row col-md-12" style={{fontSize:14, marginLeft:2}}>Payment Incomplete</div>
        </div>
        <div className="row col-md-2">
          <div className="row col-md-12" style={{width:20,height:20,border:'1px solid grey',backgroundColor:'#e3850f'}}></div>
          <div className="row col-md-12" style={{fontSize:14, marginLeft:7}}>Other Source</div>
        </div>
        </div>
        <div className="row">
        <div className="col-md-6 collection-trend">
          <TabPanel>
            <TabPanelHeader tabItems={this.state.rental_revenue_per_day_graph_tabs}/>
            <TabPanelBody>
              <TabPanelBodyContent id="1">
                <StatsTable name="court_usage_daily_data" data={statsTable} displayName="Daily Court Usage" reloadData={fetchStatsTableDataIfNeeded}/>
              </TabPanelBodyContent>
              <TabPanelBodyContent id="2">
                <StatsGraph type="line" name="court_usage_daily" data={statsGraph} reloadData={fetchStatsGraphDataIfNeeded}/>
              </TabPanelBodyContent>
            </TabPanelBody>
          </TabPanel>
        </div>  
        <div className="col-md-6 daily-trend">
          <TabPanel>
            <TabPanelHeader tabItems={this.state.rental_revenue_per_day}/>
            <TabPanelBody>
              <TabPanelBodyContent id="3">
                <StatsTable name="daily_rental" data={statsTable} displayName="Daily Rental" reloadData={fetchStatsTableDataIfNeeded}/>
              </TabPanelBodyContent>
              <TabPanelBodyContent id="4">
                <StatsGraph type="line" name="daily_rental_graph" data={statsGraph} reloadData={fetchStatsGraphDataIfNeeded}/>
              </TabPanelBodyContent>
            </TabPanelBody>
          </TabPanel>
        </div>
        </div>
        <div className="row" style={{marginTop:10}}>
            <StatsTable bigTable={true} name="partner_rental" displayName="Court Bookings List" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
          </div>
          <div className="row" style={{marginTop:10}}>
            <StatsTable bigTable={true} name="partner_bulk_booking" displayName="Bulk Bookings List" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
          </div>
          <div className="row">
            <StatsTable bigTable={true} datefilter = {true} end_date={true} name="partner_rental_collection" displayName="Rental Collection" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
          </div>
        </div>
      </div>  
      );
    }
  }
  
  export default PartnerCourtBooking;
  


// WEBPACK FOOTER //
// ./src/app/views/partner/partnerCourtBooking/PartnerCourtBooking.js